import { useTheme } from "@mui/material";
import React from "react";

const LoginSvg = () => {
  const theme = useTheme();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="830.567"
      height="711.727"
      data-name="Layer 1"
      viewBox="0 0 830.567 711.727"
    >
      <path
        fill="#e6e6e6"
        d="M68.348 169.893L455 169.893 455 296.824 440.354 296.824 440.354 330.021 407.157 296.824 68.348 296.824 68.348 169.893z"
      ></path>
      <path fill="#fff" d="M79.088 182.253H444.26V283.798H79.088z"></path>
      <path
        fill={theme.palette.primary.main}
        d="M108.453 211.9H284.274V217.23600000000002H108.453z"
      ></path>
      <path
        fill="#e6e6e6"
        d="M108.453 230.358H414.894V235.69400000000002H108.453z"
      ></path>
      <path
        fill="#e6e6e6"
        d="M108.453 248.816H414.59400000000005V254.15200000000002H108.453z"
      ></path>
      <path
        fill="#e6e6e6"
        d="M386.652 339.785L0 339.785 0 466.717 14.646 466.717 14.646 499.914 47.843 466.717 386.652 466.717 386.652 339.785z"
      ></path>
      <path
        fill="#fff"
        d="M10.74 352.146H375.91200000000003V453.69100000000003H10.74z"
      ></path>
      <path
        fill={theme.palette.primary.main}
        d="M43.035 382.769H218.856V388.105H43.035z"
      ></path>
      <path fill="#e6e6e6" d="M43.035 401.227H349.476V406.563H43.035z"></path>
      <path
        fill="#e6e6e6"
        d="M43.035 419.685H349.17600000000004V425.021H43.035z"
      ></path>
      <path
        fill="#e6e6e6"
        d="M386.652 0L0 0 0 126.931 14.646 126.931 14.646 160.129 47.843 126.931 386.652 126.931 386.652 0z"
      ></path>
      <path
        fill="#fff"
        d="M10.74 12.361H375.91200000000003V113.906H10.74z"
      ></path>
      <path
        fill={theme.palette.primary.main}
        d="M43.035 42.984H218.856V48.32H43.035z"
      ></path>
      <path fill="#e6e6e6" d="M43.035 61.442H349.476V66.778H43.035z"></path>
      <path
        fill="#e6e6e6"
        d="M43.035 79.9H349.17600000000004V85.236H43.035z"
      ></path>
      <path
        fill="#ffb8b8"
        d="M679.314 695.51L663.401 695.509 655.83 634.126 679.317 634.128 679.314 695.51z"
      ></path>
      <path
        fill="#2f2e41"
        d="M683.373 710.936l-51.313-.002v-.65a19.974 19.974 0 0119.972-19.971h31.342z"
      ></path>
      <path
        fill="#ffb8b8"
        d="M656.939 649.359L642.131 655.186 612.608 600.84 634.464 592.24 656.939 649.359z"
      ></path>
      <path
        fill="#2f2e41"
        d="M666.365 662.227l-47.75 18.79-.237-.605a19.974 19.974 0 0111.271-25.898h.001l29.164-11.476z"
      ></path>
      <path
        fill="#2f2e41"
        d="M652.09 675.565l5.066-186.225-22.548 79.833 16.292 55.393-27.029 22.975-27.552-87.905-.049-.155 27.385-144.747 80.99-3.918.58-.03.093.573c.078.482 7.732 48.542 1.295 83.298-6.411 34.623-21.904 181.496-22.06 182.976l-.066.632z"
      ></path>
      <path
        fill={theme.palette.primary.main}
        d="M627.85 426.344l-.457-.182 15.03-137.885.439-.11c15.275-3.819 35.855-3.485 46.764-2.947a7.205 7.205 0 016.748 6.093l18.07 119.012-.149.213c-12.493 17.846-31.581 22.697-48.649 22.697a115.2 115.2 0 01-37.796-6.89z"
      ></path>
      <path
        fill="#3f3d56"
        d="M699.426 466.628l-.543-.05-9.6-181.714 29.17 6.588a13.173 13.173 0 0110.126 14.504l-3.783 30.205 1.297 53.139c.903 3.264 15.673 57.335 7.467 71.424a6.544 6.544 0 01-4.063 3.292 101.773 101.773 0 01-24.057 2.815c-3.683-.001-5.958-.198-6.014-.203zM613.523 467.86a10.32 10.32 0 01-5.78-6.866c-1.901-7.653 4.516-17.277 5.442-18.613l7.762-73.733-11.545-68.115a8.681 8.681 0 017.597-10.079l32.884-3.667-1.67 70.072c14.114 47.705-16.622 116.489-16.934 117.179l-.173.381h-.418c-.166 0-4.197-.075-17.165-6.559z"
      ></path>
      <circle
        cx="850.518"
        cy="335.048"
        r="31.882"
        fill="#ffb8b8"
        transform="rotate(-28.663 573.929 649.483)"
      ></circle>
      <path
        fill="#ffb8b8"
        d="M702.308 433.742a12.172 12.172 0 0112.192-14.131l11.035-25.532L742.687 397l-16.09 35.838a12.238 12.238 0 01-24.289.904z"
      ></path>
      <path
        fill="#3f3d56"
        d="M717.846 410.347l9.113-54.677-15.566-25.943 3.965-37.012.883-.22a13.251 13.251 0 0115.112 7.104l25.428 53.066.101.212-18.468 72.554z"
      ></path>
      <path
        fill="#2f2e41"
        d="M686.698 266.62c.728.212 3.788-3.244 7.138-7.386a38.472 38.472 0 008.02-31.252c-.047-.247-.093-.481-.14-.701-1.109-5.28-6.146-10.144-11.424-9.026.398-4.678-2.752-9.084-6.746-11.553s-8.724-3.384-13.338-4.255c-5.263-.993-10.592-1.99-15.938-1.652a31.108 31.108 0 00-14.533 4.642 30.683 30.683 0 00-12.886 33.15c6.717-7.628 14.678-15.925 26.183-12.619a21.11 21.11 0 017.16 3.744c6.992 5.493 10.507 13.58 13.908 21.484 1.699-4.325 8-5.953 11.58-2.99 2.299 1.9 3.245 5.061 3.158 8.042a29.615 29.615 0 01-2.042 8.675M682.586 385.727h-1.5v-5.9a6.606 6.606 0 00-6.598-6.6h-18.803a6.606 6.606 0 00-6.599 6.6v40.802a6.606 6.606 0 006.6 6.598h18.802a6.606 6.606 0 006.598-6.598v-27.902h1.5z"
      ></path>
      <circle cx="665.586" cy="392.727" r="4" fill="#fff"></circle>
      <path
        fill="#ffb8b8"
        d="M668.85 408.666a12.172 12.172 0 00-18.059-4.713l-23.578-14.756-12.461 12.142 33.59 20.37a12.238 12.238 0 0020.509-13.043z"
      ></path>
      <path
        fill="#3f3d56"
        d="M584.519 380.557l21.575-81.505a8.724 8.724 0 019.945-6.32l7.418 1.348 7.905 43.473-16.076 36.643 29.079 17.458-4.09 32.711zM829.567 711.727h-381a1 1 0 010-2h381a1 1 0 010 2z"
      ></path>
    </svg>
  );
};

export default LoginSvg;
